import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

const API_URL = 'https://flood-chat-kmmr.onrender.com/search1';

export default function ChatSection() {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello! I'm here to offer you expert insights on flooding within Nigeria's context. Ask me anything about flood risks, forecasts, or response strategy in Nigeria.",
      isUser: false,
      timestamp: new Date()
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  const handleSendMessage = async () => {
    if (!inputValue.trim() || loading) return;

    const userMessage = {
      id: messages.length + 1,
      text: inputValue,
      isUser: true,
      timestamp: new Date()
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputValue('');
    setLoading(true);

    try {
      const res = await axios.post(API_URL, {
        query: inputValue,
        limit: 1
      });

      const aiResponse = {
        id: messages.length + 2,
        text: res.data.response || 'Sorry, I couldn’t find an answer.',
        isUser: false,
        timestamp: new Date()
      };

      setMessages((prev) => [...prev, aiResponse]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        {
          id: messages.length + 2,
          text: 'Error fetching response from server.',
          isUser: false,
          timestamp: new Date()
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendMessage();
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <section id="chat-section" className="py-16 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl mb-4">AI Flood Expert</h2>
          <p className="text-gray-600 text-lg">Get instant answers to your flood related questions</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border h-[32rem] flex flex-col">
          <div className="p-4 border-b">
            <h3 className="flex items-center space-x-2 text-lg">
              <span className="text-blue-500">🤖</span>
              <span>Flood AI Assistant</span>
            </h3>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-4">
  {messages.map((msg) => (
    <div
      key={msg.id}
      className={`flex items-start space-x-3 ${msg.isUser ? 'flex-row-reverse space-x-reverse' : ''}`}
    >
      <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm ${
        msg.isUser ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-600'
      }`}>
        {msg.isUser ? '👤' : '🤖'}
      </div>

      <div className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg ${
        msg.isUser ? 'bg-blue-500 text-white' : 'bg-white border border-gray-200'
      }`}>
        {msg.isUser ? (
          <p className="text-sm whitespace-pre-line">{msg.text}</p>
        ) : (
          <div className="text-sm prose prose-sm max-w-full">
            <ReactMarkdown>{msg.text}</ReactMarkdown>
          </div>
        )}
        <p className={`text-xs mt-1 ${msg.isUser ? 'text-blue-100' : 'text-gray-500'}`}>
          {msg.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </p>
      </div>
    </div>
  ))}
  <div ref={scrollRef}></div>
</div>

          <div className="flex space-x-2 p-4 border-t">
            <input
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ask about weather, floods, or forecasts..."
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleSendMessage}
              className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={loading}
            >
              ➤
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
